import { biHottag } from '@tencent/ppd-base-libs';

const ExposureReportList = []; // 记录已上报项目，不重复上报曝光
// 上报曝光逻辑，外加点击逻辑封装
export default function reportBi(action, targetElement) {
  // console.log('targetElement',targetElement)
  // 这里是上报的具体逻辑，注意这里需要将id，index排列索引，和对应的type类型如产品、tab、标签，
  // 以data-report-id,data-report-type,data-report-index,放在DOM元素上，方便observe查找元素上的上报信息
  const type = targetElement.dataset.reportType;
  const typeId = targetElement.dataset.reportTypeId;
  const typePosition = targetElement.dataset.reportTypePosition;
  if (!type) return;

  // 曝光不重复上报，点击可多次上报
  if (action == 'brow') {
    if (ExposureReportList.indexOf(`${type}-${typeId}`) > -1) return; // 单页不重复上报已曝光产品或元素
    ExposureReportList.push(`${type}-${typeId}`);
  }

  // 上报拓展字段转字符串
  const ext = {};
  if (typeId) ext.fuid = typeId;
  if (typePosition) ext.fposition = typePosition;
  let source = 'scenes';
  if (type === 'entrance') {
    source = 'channel';
  }
  // 上报
  // console.log(`wallet.goods.${source}.${type}_${action}`, ext);
  biHottag(`wallet.goods.${source}.${type}_${action}`, ext);
}
